// tooltip.jsx
"use client"

import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

export const TooltipProvider = TooltipPrimitive.Provider

export const Tooltip = ({ children, ...props }) => (
    <TooltipPrimitive.Root {...props}>{children}</TooltipPrimitive.Root>
)

export const TooltipTrigger = TooltipPrimitive.Trigger

export const TooltipContent = React.forwardRef(
    ({ className, sideOffset = 4, ...props }, ref) => (
        <TooltipPrimitive.Portal>
            <TooltipPrimitive.Content
                ref={ref}
                sideOffset={sideOffset}
                className="z-50 rounded-md bg-black px-3 py-1.5 text-sm text-white shadow-md animate-in fade-in-0 zoom-in-95"
                {...props}
            />
        </TooltipPrimitive.Portal>
    )
)

TooltipContent.displayName = TooltipPrimitive.Content.displayName
